<template>
  <div
    class="c-connect-promottion bg-white br--medium ax-shadow
      ax-shadow--medium text-center"
  >
    <h3 class="fs-25 w-black darks">
      Conecta con
      <span class="pri-alt">empresas, clientes y oportunidades</span>
    </h3>
    <p class="w-medium">
      Unete a la comunidad de Arcux donde el mejor talento comparte
      sus proyectos, habilidades, etc. con el mundo
    </p>
    <button
      @click="createProfile()"
      class="c-button c-button--primary px-4 medium d-inline-block"
      :class="{loading : isLoading}"
      :disabled="isLoading"
    >
      {{(isLoading) ? 'Creando perfil...' : 'Crear mi perfil'}}
      <img
        class="c-button__spinner"
        src="@/assets/images/animations/spinner-white.png"
        alt="loading"
      />
    </button>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
  },
  methods: {
    createProfile() {
      this.isLoading = true;

      fetch(`${process.env.VUE_APP_API_V2}/work/profiles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: this.userData.id,
        }),
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            window.location.href = `${process.env.VUE_APP_SITE}/es/profesionales/${response.data.slug}`;
          } else {
            this.isLoading = false;

            Vue.$toast.open({
              message: response.message,
              type: 'error',
              position: 'bottom-left',
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;

          let errorMessage = '';

          try {
            errorMessage = JSON.parse(error.message)?.message;
          } catch (err) {
            errorMessage = error.message;
          }

          Vue.$toast.open({
            message: errorMessage,
            type: 'error',
            position: 'bottom-left',
          });
        });
    },
  },
};
</script>
